import QuestionForm from "@/components/Questions/QuestionForm"
import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/_layout/questions/add")({
  component: AddQuestion,
})

function AddQuestion() {
  return <QuestionForm mode="add" />
}
